<div class="content">
  <div class="title"
       i18n="@@Pipeliner_Applications">Pipeliner Applications</div>

  <div class="buttons">
    <a [href]="crmLink"
       #app
       class="button"
       pplPopoverClose>
      <ppl-icon svgIcon="pipeliner-switcher"
                width="56px"
                height="24px"
                [actionElement]="app"
                hoverEnabled="true"></ppl-icon>
      <ng-container i18n="@@CRM_Application">CRM Application</ng-container>
    </a>

    <a *ngIf="hasAccessToCustomerPortal$ | async"
       [href]="customerPortalLink"
       #customerPortal
       class="button"
       pplPopoverClose>
      <ppl-icon svgIcon="billing-switcher-blue"
                width="56px"
                height="24px"
                [actionElement]="customerPortal"
                hoverEnabled="true"></ppl-icon>
      <ng-container i18n="@@Billing">Billing</ng-container>
    </a>

    <a *ngIf="hasAccessToBusinessCenter$ | async"
       [href]="businessCenterLink"
       #businessCenter
       class="button"
       pplPopoverClose>
      <ppl-icon svgIcon="business-center-switcher-blue"
                width="56px"
                height="30px"
                [actionElement]="businessCenter"
                hoverEnabled="true"></ppl-icon>
      Business Center
    </a>

    <a *ngIf="hasAccessToPartnerPortal$ | async"
       [href]="partnerPortalLink"
       #partnerPortal
       class="button"
       pplPopoverClose>
      <ppl-icon svgIcon="partners-switcher-blue"
                width="56px"
                height="30px"
                [actionElement]="partnerPortal"
                hoverEnabled="true"></ppl-icon>
      Partner Portal
    </a>
  </div>

  <div class="title"
       i18n="@@Pipeliner_Universe">Pipeliner Universe</div>

  <a #goAhead
     class="button"
     href="https://go-ahead.global"
     target="_blank"
     pplPopoverClose
     i18n-title="@@GoAheadTooltip"
     title="The go-to online magazine for sales-related, multimedia content from over +350 sales thought leaders.">
    <ppl-icon svgIcon="goahead-switcher"
              width="56px"
              height="21px"
              [actionElement]="goAhead"
              hoverEnabled="true"></ppl-icon>
    <ng-container i18n="@@GoAhead">Go Ahead!</ng-container>
  </a>

  <a #salesPop
     class="button"
     href="https://salespop.net"
     target="_blank"
     pplPopoverClose
     i18n-title="@@SalesPopTooltip"
     title="Global in-person networking platform featuring top, expert speakers.">
    <ppl-icon svgIcon="salespop-switcher"
              width="56px"
              height="24px"
              [actionElement]="salesPop"
              hoverEnabled="true"></ppl-icon>
    <ng-container i18n="@@SalesPOP">Sales POP!</ng-container>
  </a>
</div>
